type TranslateFn = (key: string, options?: { [key: string]: any }) => string;

const defaultCompanySizeLabels: Record<number, string> = {
  1: "Solo",
  10: "2–3 people",
  50: "4–6 people",
  250: "7–10 people",
  500: "11+ people",
};

const companySizeTranslationKeys: Record<number, string> = {
  1: "resources.companies.sizes.one_employee",
  10: "resources.companies.sizes.two_to_nine_employees",
  50: "resources.companies.sizes.ten_to_forty_nine_employees",
  250: "resources.companies.sizes.fifty_to_two_hundred_forty_nine_employees",
  500: "resources.companies.sizes.two_hundred_fifty_or_more_employees",
};

export const getTranslatedCompanySizeLabel = (
  size: { id: number; name: string },
  translate: TranslateFn,
) => {
  const defaultLabel = defaultCompanySizeLabels[size.id];
  const translationKey = companySizeTranslationKeys[size.id];
  if (!defaultLabel || !translationKey || size.name !== defaultLabel) {
    return size.name;
  }

  return translate(translationKey, { _: size.name });
};
